import { SelectionModel } from '@angular/cdk/collections';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import {
  SaleVetModel,
  SaleVetTableFields,
} from 'src/app/models/sales/sale-vet.model';
import { Helper } from 'src/app/utils/helper/helper';
import { VetProfileNotificationDetailPopupComponent } from '../../profile-page/vet-profile-notification-detail-popup/vet-profile-notification-detail-popup.component';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { SaleVetListDataSource } from './sale-vet-list-datasource';
@Component({
  selector: 'app-sale-vet-list',
  templateUrl: './sale-vet-list.component.html',
  styleUrls: ['./sale-vet-list.component.scss'],
  providers: [Helper],
})
export class SaleVetListComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  @Input() public tab: string;
  @Input() public saleVets: SaleVetModel[] = null;
  @Input() public set allSalesVets(vets: SaleVetModel[]) {
    this.saleVets = this.helper.deepCopy(vets);
    if (this.saleVets?.length > 0) {
      setTimeout(() => {
        this.dataSource = new SaleVetListDataSource(
          this.saleVets,
          this.vetSort
        );
        this.searchDataSource(this._searchTerm);
        this.selection.clear();
        this.dataSource.data?.forEach(vet => {
          if (this.defaultSelected.some(sel => sel.userId === vet.userId)) {
            this.selection.select(vet);
          }
        });
      }, 100)

    }
  }
  @Input() public salesVetsCount = 0;
  @Input() set searchTerm(value: string) {
    this._searchTerm = value;
    this.searchDataSource(value);
  }
  private _searchTerm: string;
  @Input() public defaultSelected: any[]=[];
  @Input() public isLoaderSaleVets: boolean = true;
  @Output() vetSelectionEvent = new EventEmitter<any>();
  @Output() onVetContactInfoUpdate = new EventEmitter<any>();
  public checkedAll = false;
  public selection = new SelectionModel<SaleVetModel>(true, []);

  public checkboxVetIds: number[];

  public saleVetTableFields = SaleVetTableFields;

  public dataSource: SaleVetListDataSource;
  public displayedColumns$ = new BehaviorSubject([
    'checkbox',
    'firstName',
    'lastName',
    'clinic',
    'email',
    'mobile',
    'inDraft',
    'inReview',
    'denied',
    'approved',
    'lotsViewed',
    'action',
  ]);
  @ViewChild(MatSort) vetSort: MatSort;
  constructor(private readonly helper: Helper, private readonly modalService: NgbModal) {
    super();
  }


  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource?.data.length;
    return numSelected === numRows;
  }
  public onTableScroll(): void {
    this.dataSource.onScroll();
  }
  trackById(index: number, item: SaleVetModel): any {
    return item.memberId;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear()
    } else {
      this.dataSource.data.forEach((row) => {
        this.selection.select(row)
      });
    }
    this.vetSelectionEvent.emit({
      selectedVets: this.selection.selected,
    });

  }
  onSingleChange($event: any, element: any) {
    if ($event) {
      this.selection.toggle(element)
      this.vetSelectionEvent.emit({
        selectedVets: this.selection.selected,
      });
    }
  }

  vetProfileDetail(vet: SaleVetModel): void {
    
    const modalRef = this.modalService.open(VetProfileNotificationDetailPopupComponent, {
      size: '50-width',
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.data = { userId: vet.userId, memberId: vet.memberId, Name: `${vet.firstName} ${vet.lastName}` };
    
    modalRef.result.then(
      (result) => {
        this.onVetContactInfoUpdate.emit({ userId: vet.userId });
      },
      (reason) => {
        //this.activityEnd.emit(Activity.XRayView);
      }
    );
  }

  private searchDataSource(searchTerm: string) {
    if (searchTerm == undefined || searchTerm == null) {
      return;
    }
    if (this.dataSource) {
      if (searchTerm === '') {
        this.dataSource?.clearFilter(); // Add a method to reset the data
      } else {
        this.dataSource.searchTable(searchTerm);
      }
    }
  }

  public ngOnInit(): void {}

 
}
